import { useQueryClient, useMutation } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import useActiveWorkspace from "@/hooks/useActiveWorkspace";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export const useSaveDataset = (userToken: string) => {
  const queryClient = useQueryClient();
  const activeWorkspace = useActiveWorkspace();

  return useMutation(
    ({ dataset_id }: { dataset_id: string; dataset_group_id?: string }) =>
      fetch(ENDPOINTS.save_dataset, {
        method: "POST",
        headers: jsonAuthHeaders(userToken),
        body: JSON.stringify({
          dataset_id,
        }),
      }).then(handleResponse),
    {
      onSuccess: (_, body) => {
        queryClient.invalidateQueries([ENDPOINTS.get_datasets(activeWorkspace?.id ?? 0)]);
        queryClient.invalidateQueries([ENDPOINTS.datasets]);
        queryClient.invalidateQueries([ENDPOINTS.save_dataset]);
        queryClient.invalidateQueries([
          "changelog",
          String(activeWorkspace?.id),
          Number(body.dataset_group_id),
          "DATASET",
        ]);
        queryClient.invalidateQueries(["global-changelog", String(activeWorkspace?.id)]);
      },
    },
  );
};
